import { useInfiniteQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export function useSessions(siteId: string) {
  return useInfiniteQuery({
    queryKey: ['sessions', siteId],
    queryFn: ({ pageParam }: { pageParam?: string }) =>
      api.sites.sessions(siteId, { limit: 50, cursor: pageParam }),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (last) => last.cursor,
  });
}
